import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import { WEB_PLACEMENTS, sizeHint, checkAdImage } from '../../common/adSizes';
import { renderAd } from './SponsorSlot';
const PLACEMENTS = {
  newsletter: 'Newsletter sponsorship',
  calculator: 'Calculator result sponsorship',
  country_branding: 'Country tool branding',
  forum_feed: 'Forum feed ad',
  banner: 'Forum sidebar ad',
  page_banner: 'In-page banner',
  tag: 'Sponsored sticky post',
  sponsored_content: 'Sponsored article',
  dedicated_email: 'Dedicated partner email'
};
const words = t => (String(t || '').trim().match(/\S+/g) || []).length;
const today = () => new Date().toISOString().slice(0, 10);
const api = path => app.forum.attribute('apiUrl') + '/voucha-ads/portal' + path;

/** /advertiser - a sponsor's own bookings, results, and ad submissions (reviewed by Voucha before running). */
export default class AdvertiserPage extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.editing = null; // booking id
    this.form = null;
    this.busy = false;
    this.error = null;
    this.notice = null;
    app.setTitle('Your advertising');
    this.load();
  }
  async load() {
    try {
      this.data = await app.request({
        method: 'GET',
        url: api(''),
        errorHandler: () => {}
      });
    } catch (e) {
      this.data = {
        state: 'error'
      };
    }
    m.redraw();
  }
  view() {
    const d = this.data;
    if (!d) return m("div", {
      className: "VouchaAdvertiser container"
    }, m(LoadingIndicator, null));
    if (d.state === 'guest') {
      return m("div", {
        className: "VouchaAdvertiser container"
      }, m("div", {
        className: "VouchaAdvertiser-box"
      }, m("h1", null, "Your advertising on Voucha"), m("p", null, "Log in with the account we linked to your company (or sign up with the email address we invited) to see your bookings and results."), m("p", {
        className: "VouchaAdvertiser-muted"
      }, "Use Log In or Sign Up at the top of the page.")));
    }
    if (d.state !== 'ok') {
      return m("div", {
        className: "VouchaAdvertiser container"
      }, m("div", {
        className: "VouchaAdvertiser-box"
      }, m("h1", null, "No advertiser account yet"), m("p", null, "Your login isn't linked to an advertiser on Voucha. If you advertise with us, email", ' ', m("a", {
        href: 'mailto:' + (d.contactEmail || 'advertise@thevoucha.com')
      }, d.contactEmail || 'advertise@thevoucha.com'), " and we'll link it. Interested in advertising? ", m("a", {
        href: app.route('voucha-ads.advertise')
      }, "See our options"), ".")));
    }
    return m("div", {
      className: "VouchaAdvertiser container"
    }, m("header", {
      className: "VouchaAdvertiser-head"
    }, m("div", null, m("h1", null, d.sponsor.name), m("p", {
      className: "VouchaAdvertiser-muted"
    }, "Your advertising on Voucha", d.sponsor.isFoundingPartner ? ' · Founding Partner' : '')), d.sponsor.reportUrl ? m(Button, {
      className: "Button",
      icon: "fas fa-link",
      onclick: () => this.copy(d.sponsor.reportUrl)
    }, "Copy shareable report link") : null), this.notice ? m("p", {
      className: "VouchaAdvertiser-notice"
    }, this.notice) : null, d.bookings.map(b => this.booking(b)), !d.bookings.length ? m("p", {
      className: "VouchaAdvertiser-muted"
    }, "No bookings yet. We'll add them here once your campaign is agreed.") : null, m("p", {
      className: "VouchaAdvertiser-muted VouchaAdvertiser-small"
    }, "Questions? Email ", m("a", {
      href: 'mailto:' + d.contactEmail
    }, d.contactEmail), ". Figures are totals only; we never share information about individual readers."));
  }
  copy(text) {
    navigator.clipboard?.writeText(text);
    this.notice = 'Report link copied. Anyone with the link can see these results.';
  }
  bookingState(b) {
    if (b.status === 'paused') return 'Paused';
    if (b.status === 'draft') return 'Being set up';
    if (b.paymentStatus !== 'paid') return 'Awaiting payment';
    if (b.issuesLimit !== null && b.issuesUsed >= b.issuesLimit) return 'Completed';
    if (b.startsOn > today()) return 'Scheduled';
    if (b.endsOn < today()) return 'Ended';
    return 'Running';
  }
  booking(b) {
    const r = b.results || {
      runs: 0,
      reach: 0,
      clicks: 0,
      ctr: null,
      issues: []
    };
    const hasLive = b.live.headline || b.live.imageUrl;
    return m("section", {
      className: "VouchaAdvertiser-card"
    }, m("div", {
      className: "VouchaAdvertiser-cardHead"
    }, m("div", null, m("h2", null, PLACEMENTS[b.placement] || b.placement), m("div", {
      className: "VouchaAdvertiser-muted"
    }, b.startsOn, " to ", b.endsOn, b.placement === 'newsletter' ? ' · ' + (b.editions.length ? b.editions.join(', ') : 'All newsletters') : '', b.issuesLimit !== null ? ' · ' + b.issuesUsed + ' of ' + b.issuesLimit + ' issues' : '')), m("span", {
      className: "VouchaAdvertiser-pill"
    }, this.bookingState(b))), m("div", {
      className: "VouchaAdvertiser-stats"
    }, b.placement === 'newsletter' ? m("div", null, m("strong", null, r.reach.toLocaleString('en-US')), m("span", null, "Readers reached")) : m("div", null, m("strong", null, (r.impressions || 0).toLocaleString('en-US')), m("span", null, "Impressions")), m("div", null, m("strong", null, r.clicks.toLocaleString('en-US')), m("span", null, "Clicks")), m("div", null, m("strong", null, r.ctr !== null ? r.ctr + '%' : '–'), m("span", null, "Click rate"))), r.issues.length ? m("table", {
      className: "VouchaAdvertiser-table"
    }, m("thead", null, m("tr", null, m("th", null, "Issue"), m("th", null, "Sent"), m("th", {
      className: "n"
    }, "Readers"), m("th", {
      className: "n"
    }, "Clicks"))), m("tbody", null, r.issues.map(i => m("tr", null, m("td", null, i.label), m("td", null, i.date), m("td", {
      className: "n"
    }, i.reach.toLocaleString('en-US')), m("td", {
      className: "n"
    }, i.clicks !== null ? i.clicks : '–'))))) : null, m("div", {
      className: "VouchaAdvertiser-ads"
    }, hasLive ? m("div", null, m("h3", null, b.status === 'approved' ? 'Your approved ad' : 'Your ad'), this.preview(b.live, b.placement)) : null, b.pending ? m("div", null, m("h3", null, b.reviewStatus === 'changes_requested' ? 'Changes requested' : 'Waiting for our review'), b.reviewStatus === 'changes_requested' && b.reviewNote ? m("p", {
      className: "VouchaAdvertiser-note"
    }, b.reviewNote) : null, b.reviewStatus !== 'changes_requested' ? m("p", {
      className: "VouchaAdvertiser-muted"
    }, hasLive && b.status === 'approved' ? 'Your approved ad keeps running until we review this version.' : "We'll review it and email you.") : null, this.preview(b.pending, b.placement)) : null), this.editing === b.id ? this.editor(b) : m(Button, {
      className: "Button Button--primary",
      onclick: () => this.startEdit(b)
    }, b.pending && b.reviewStatus === 'changes_requested' ? 'Update your ad' : hasLive || b.pending ? 'Edit your ad' : 'Send us your ad'));
  }
  startEdit(b) {
    this.imageWarning = null;
    const src = b.pending || b.live;
    this.editing = b.id;
    this.error = null;
    this.form = {
      headline: src.headline || '',
      body: src.body || '',
      ctaLabel: src.ctaLabel || 'Learn more',
      ctaUrl: src.ctaUrl || '',
      imageUrl: b.imageLocked ? b.live.imageUrl : src.imageUrl || '',
      mobileImageUrl: b.imageLocked ? b.live.mobileImageUrl || '' : src.mobileImageUrl || ''
    };
    this.mobileWarning = null;
  }
  editor(b) {
    const f = this.form;
    const count = words(f.body);
    return m("div", {
      className: "VouchaAdvertiser-editor"
    }, WEB_PLACEMENTS.includes(b.placement) ? m("div", null, m("p", {
      className: "VouchaAdvertiser-muted"
    }, "On the website your ", m("strong", null, "image is the whole ad"), ": put your brand, message and call to action in the image, and it links to your page. It shows with a small \"Sponsored\" label. ", sizeHint(b.placement)), m("div", {
      className: "VouchaAdvertiser-grid"
    }, m("label", null, "Link (https://\u2026)", m("input", {
      className: "FormControl",
      value: f.ctaUrl,
      oninput: e => f.ctaUrl = e.target.value
    })), m("label", null, "Alt text (what the image says, for screen readers)", m("input", {
      className: "FormControl",
      maxlength: "150",
      value: f.headline,
      oninput: e => f.headline = e.target.value
    })))) : m("div", null, b.placement === 'newsletter' ? m("p", {
      className: "VouchaAdvertiser-muted"
    }, m("strong", null, "Sponsored story"), ": a headline and up to 150 words, with an optional image. ", m("strong", null, "Banner"), ": leave the headline empty and upload one image. ", sizeHint('newsletter')) : null, m("label", null, "Headline", m("input", {
      className: "FormControl",
      maxlength: "150",
      value: f.headline,
      oninput: e => f.headline = e.target.value
    })), m("label", null, "Text ", m("span", {
      className: 'VouchaAdvertiser-count' + (count > 150 ? ' is-over' : '')
    }, count, " / 150 words"), m("textarea", {
      className: "FormControl",
      rows: "6",
      value: f.body,
      oninput: e => f.body = e.target.value,
      placeholder: "Leave a blank line between paragraphs."
    })), m("div", {
      className: "VouchaAdvertiser-grid"
    }, m("label", null, "Button text", m("input", {
      className: "FormControl",
      maxlength: "60",
      value: f.ctaLabel,
      oninput: e => f.ctaLabel = e.target.value
    })), m("label", null, "Link (https://\u2026)", m("input", {
      className: "FormControl",
      value: f.ctaUrl,
      oninput: e => f.ctaUrl = e.target.value
    })))), m("div", {
      className: "VouchaAdvertiser-image"
    }, m("span", null, b.placement === 'page_banner' ? 'Desktop image (1940 × 500)' : 'Image'), f.imageUrl ? m("img", {
      src: f.imageUrl,
      alt: ""
    }) : null, this.imageWarning ? m("p", {
      className: "VouchaAdvertiser-error"
    }, this.imageWarning) : null, b.imageLocked ? m("p", {
      className: "VouchaAdvertiser-muted"
    }, "Your image is approved and running, so it can't be changed here. To use a different image, email", ' ', m("a", {
      href: 'mailto:' + this.data.contactEmail
    }, this.data.contactEmail), ".") : m("div", {
      className: "VouchaAdvertiser-imageRow"
    }, m("input", {
      type: "file",
      accept: "image/png,image/jpeg,image/webp,image/gif",
      onchange: e => this.upload(e)
    }), m("span", {
      className: "VouchaAdvertiser-muted VouchaAdvertiser-small0"
    }, "JPG, PNG, GIF or WebP, up to ", this.data.upload?.maxLabel || '5 MB', ". Story image 1200\xD7630; banner 600\xD7500."), f.imageUrl ? m(Button, {
      className: "Button Button--link",
      onclick: () => f.imageUrl = ''
    }, "Remove image") : null, this.busy === 'upload' ? m(LoadingIndicator, {
      display: "inline",
      size: "small"
    }) : null)), b.placement === 'page_banner' ? m("div", {
      className: "VouchaAdvertiser-image"
    }, m("span", null, "Mobile image (600 \xD7 500)"), f.mobileImageUrl ? m("img", {
      src: f.mobileImageUrl,
      alt: "",
      className: "is-mobile"
    }) : null, this.mobileWarning ? m("p", {
      className: "VouchaAdvertiser-error"
    }, this.mobileWarning) : null, b.imageLocked ? null : m("div", {
      className: "VouchaAdvertiser-imageRow"
    }, m("input", {
      type: "file",
      accept: "image/png,image/jpeg,image/webp,image/gif",
      onchange: e => this.upload(e, 'mobileImageUrl')
    }), m("span", {
      className: "VouchaAdvertiser-muted VouchaAdvertiser-small0"
    }, "Shown on phones. Without it, phones show your desktop image scaled down, which is usually too small to read."), f.mobileImageUrl ? m(Button, {
      className: "Button Button--link",
      onclick: () => f.mobileImageUrl = ''
    }, "Remove image") : null, this.busy === 'upload-mobileImageUrl' ? m(LoadingIndicator, {
      display: "inline",
      size: "small"
    }) : null)) : null, f.headline || f.imageUrl ? m("div", null, m("h3", null, "Preview"), this.preview(f, b.placement)) : null, this.error ? m("p", {
      className: "VouchaAdvertiser-error"
    }, this.error) : null, m("div", {
      className: "VouchaAdvertiser-actions"
    }, m(Button, {
      className: "Button Button--primary",
      loading: this.busy === 'submit',
      onclick: () => this.submit(b)
    }, "Send for review"), m(Button, {
      className: "Button",
      onclick: () => this.editing = null
    }, "Cancel")));
  }

  /** Same look as the newsletter's sponsor block */
  preview(ad, placement) {
    if (WEB_PLACEMENTS.includes(placement) && ad.imageUrl) {
      return m("div", {
        className: "VouchaAdvertiser-displayPreview"
      }, renderAd({
        ...ad,
        placement,
        ctaUrl: '#'
      }));
    }
    if (!ad.headline && ad.imageUrl) {
      return m("div", {
        className: "VouchaAdvertiser-banner"
      }, m("div", {
        className: "VouchaAdvertiser-adLabel"
      }, "Advertisement"), m("img", {
        src: ad.imageUrl,
        alt: ""
      }));
    }
    return m("div", {
      className: "VouchaAdvertiser-ad"
    }, m("div", {
      className: "VouchaAdvertiser-adLabel"
    }, "A message from our ", this.data.sponsor.isFoundingPartner ? 'founding partner' : 'sponsor'), ad.imageUrl ? m("img", {
      className: "VouchaAdvertiser-adImage",
      src: ad.imageUrl,
      alt: ""
    }) : null, m("div", {
      className: "VouchaAdvertiser-adTagLine"
    }, m("span", {
      className: "VouchaAdvertiser-adTag"
    }, "Sponsored"), " \xB7 ", this.data.sponsor.name), m("div", {
      className: "VouchaAdvertiser-adHeadline"
    }, ad.headline), String(ad.body || '').split(/\n\s*\n/).filter(p => p.trim()).map(p => m("p", null, p)), m("span", {
      className: "VouchaAdvertiser-adLink"
    }, (ad.ctaLabel || 'Learn more') + ' →'));
  }
  async upload(event, key = 'imageUrl') {
    const file = event.target.files && event.target.files[0];
    if (!file) return;
    // Stop oversized files before uploading
    const max = this.data.upload?.maxBytes;
    if (max && file.size > max) {
      this.error = 'That image is ' + (file.size / 1048576).toFixed(1) + ' MB. The limit is ' + this.data.upload.maxLabel + '. Try saving it as a JPG, or at a smaller size.';
      event.target.value = '';
      return;
    }
    const body = new FormData();
    body.append('image', file);
    this.busy = key === 'imageUrl' ? 'upload' : 'upload-' + key;
    this.error = null;
    m.redraw();
    try {
      const r = await app.request({
        method: 'POST',
        url: api('/images'),
        body,
        errorHandler: () => {}
      });
      this.form[key] = r.url;
      const booking = this.data.bookings.find(x => x.id === this.editing);
      if (key === 'mobileImageUrl') this.mobileWarning = await checkAdImage(r.url, 'page_banner_mobile');else this.imageWarning = booking ? await checkAdImage(r.url, booking.placement) : null;
    } catch (e) {
      this.error = e?.response?.message || 'The upload failed. Please try again.';
    }
    event.target.value = '';
    this.busy = false;
    m.redraw();
  }
  async submit(b) {
    this.busy = 'submit';
    this.error = null;
    m.redraw();
    try {
      await app.request({
        method: 'POST',
        url: api('/bookings/' + b.id),
        body: this.form,
        errorHandler: () => {}
      });
      this.editing = null;
      this.notice = "Thanks, we've received your ad and will review it shortly. We'll email you when it's approved.";
      await this.load();
      window.scrollTo(0, 0);
    } catch (e) {
      this.error = e?.response?.message || "That didn't send. Please try again.";
    }
    this.busy = false;
    m.redraw();
  }
}
flarum.reg.add('voucha-ads', 'forum/components/AdvertiserPage', AdvertiserPage);